import PasswordReset from "./password-reset";

export default PasswordReset;
